export default {"src":"/_next/static/media/lifesbuoy75_40.c6323d81.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};